export const CHANGE_MAP_MODE = 'CHANGE_MAP_MODE';
export const CHANGE_MAP_MODE_PENDING = 'CHANGE_MAP_MODE_PENDING';
export const CHANGE_MAP_MODE_SUCCESS = 'CHANGE_MAP_MODE_SUCCESS';
export const CHANGE_MAP_MODE_FAILURE = 'CHANGE_MAP_MODE_FAILURE';
